export default "__VITE_ASSET__D_ca7ire__"